export function isPromiseLike<T>(o?: any): o is PromiseLike<T> {
    return o instanceof Promise
        || typeof o?.then === 'function';
}